<template>
  <!--  <div class="btn-group btn-group-toggle" data-toggle="buttons">-->
  <div class="flex">
    <div>
      <input type="radio" id="p_1" v-model="drug.priority" value="1">
      <label for="p_1" v-bind:class="{'btn btn-danger': true, 'active':drug.priority == 1}"/>
    </div>
    <div>
      <input id="p_2" type="radio" v-model="drug.priority" value="2">
      <label for="p_2" v-bind:class="{'btn btn-warning': true, 'active':drug.priority == 2}"/>
    </div>
    <div>
      <input id="p_3" type="radio" v-model="drug.priority" value="3">
      <label for="p_3" v-bind:class="{'btn btn-success': true, 'active':drug.priority == 3}"/>
    </div>
    <div>
      <input id="p_4" type="radio" v-model="drug.priority" value="4">
      <label for="p_4" v-bind:class="{'btn btn-dark': true, 'active':drug.priority == 4}"/>
    </div>
    <div>
      <input id="p_5" type="radio" v-model="drug.priority" value="5">
      <label for="p_5" v-bind:class="{'btn btn-black': true, 'active':drug.priority == 5}"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['drug']
}
</script>

<style scoped>
.flex label {
  margin-bottom: 0;
  border-radius: 50%;
  padding: 10px 10px !important;
  margin-right: 10px;
}

.flex input {
  vertical-align: middle;
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #bababa;
}

.btn-dark,
.btn-outline-dark:hover {
  color: #212529;
  background-color: #bababa;
  border-color: #bababa;
}

.btn-outline-black {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}

.btn-outline-black.active,
.btn-black,
.btn-black:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}

</style>
